import { ScrollToTop } from '@breuni-ui/bdk-scroll-to-top';
import { safeDefine } from '@breuni-ui/safe-define';

// empty by intention
class EntsScrollToTop extends ScrollToTop {}

// @breuni-ui/bdk-scroll-to-top's .d.ts is built with a newer TypeScript than this project uses,
// which breaks the HTMLElement inheritance chain when type-checked here.
safeDefine('ents-scroll-to-top', EntsScrollToTop as unknown as CustomElementConstructor);
